import React from "react";
import Avatar from '@mui/material/Avatar';
import Tooltip from "@mui/material/Tooltip";
import { getUserAvatar, getUser } from '../../Utils/Common';
export default function CustomAvatar({ alt, imgSrc, avatarColor }) {
  const getLoginInfo = () => {
    return (
      <>
        {getUser()}
      </>
    );
  };

    return (
        <>
            <Tooltip arrow title={getLoginInfo()} placement="bottom">
                <Avatar src={imgSrc} alt={alt} sx={{ width: 32, height: 32, bgcolor: avatarColor }}>{getUserAvatar()}</Avatar>
            </Tooltip>
        </>

    );
};